import { useState, useEffect } from "react";
import axios from "axios";
import Sidebar from "../../components/sidebar/Sidebar";
import Navbar from "../../components/navbar/Navbar";
import DriveFolderUploadOutlinedIcon from "@mui/icons-material/DriveFolderUploadOutlined";
import "./new.scss";

const New = ({ inputs, title }) => {
  const [file, setFile] = useState("");
  const [info, setInfo] = useState({});
  const [courses, setCourses] = useState([]); // State to hold list of courses
  const [selectedCourses, setSelectedCourses] = useState([]); // State to hold selected course IDs

  // Fetch courses from the backend
  useEffect(() => {
    const fetchCourses = async () => {
      try {
        const response = await axios.get("https://api.mecdistanceeducation.com/api/courses/");
        setCourses(response.data); // Set the courses in state
      } catch (error) {
        console.error("Error fetching courses:", error);
      }
    };

    fetchCourses();
  }, []); // Empty dependency array to run only on component mount

  const handleChange = (e) => {
    setInfo((prev) => ({ ...prev, [e.target.id]: e.target.value }));
  };

  const handleCourseChange = (e) => {
    const selected = Array.from(e.target.selectedOptions, option => option.value);
    setSelectedCourses(selected); // Update selected courses
  };

  const handleClick = async (e) => {
    e.preventDefault();
    const data = new FormData();
    data.append("file", file);
    data.append("upload_preset", "upload");
    try {
      const { url } = data; // Mock URL for now

      const newUser = {
        ...info,
        img: url,
        courses: selectedCourses, // Send selected courses in the request
      };

      await axios.post("https://api.mecdistanceeducation.com/api/auth/register", newUser);
      window.location.href = `${window.location.origin}/users`;
    } catch (err) {
      console.log(err);
    }
  };

  return (
    <div className="new">
      <Sidebar />
      <div className="newContainer">
        <Navbar />
        <div className="top">
          <h1>{title}</h1>
        </div>
        <div className="bottom">
          <div className="left">
            <img
              src={
                file
                  ? URL.createObjectURL(file)
                  : "https://icon-library.com/images/no-image-icon/no-image-icon-0.jpg"
              }
              alt=""
            />
          </div>
          <div className="right">
            <form>
              <div className="formInput">
                <label htmlFor="file">
                  Image: <DriveFolderUploadOutlinedIcon className="icon" />
                </label>
                <input
                  type="file"
                  id="file"
                  onChange={(e) => setFile(e.target.files[0])}
                  style={{ display: "none" }}
                />
              </div>

              {inputs.map((input) => (
                <div className="formInput" key={input.id}>
                  <label>{input.label}</label>
                  <input
                    onChange={handleChange}
                    type={input.type}
                    placeholder={input.placeholder}
                    id={input.id}
                  />
                </div>
              ))}

              {/* Dropdown for selecting courses */}
              <div className="formInput">
                <label>Courses</label>
                <select multiple onChange={handleCourseChange}>
                  {courses.map((course) => (
                    <option value={course._id} key={course._id}>
                      {course.name} {/* Assuming each course has a name field */}
                    </option>
                  ))}
                </select>
              </div>

              <button onClick={handleClick}>Create new user</button>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default New;
